<template>
  <div :class="dealerID > 0 ? '' : 'content-container'">
    <el-breadcrumb v-if="dealerID == 0" separator="/">
      <el-breadcrumb-item :to="{ path: '/dashboard' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>客户列表</el-breadcrumb-item>
    </el-breadcrumb>
    <customer-list
      :deleted="false"
      :dealerID="dealerID"
      :category="3"
    ></customer-list>
  </div>
</template>

<script>
import CustomerList from './list'
export default {
  props: {
    dealerID: {
      type: Number,
      default: 0,
    },
  },
  components: { CustomerList },
}
</script>